const subjectForm = {
  /**
   * Client form key
   * @type {String}
   */
  key: 'subjectForm',

  /**
   * Client form fields object
   * @type {Object}
   */
  fields: {
    subjectableId: null,
    subjectableType: null,
    type: null,
    disputeValue: '',
    courtCaseNumber: '',
    internalSubjectNumber: '',
    courtName: '',
    actingJudge: '',
    note: '',
  },

  /**
   * Client form helpers object
   * @type {Object}
   */
  helpers: {
    clientOptions: [],
    subjectTypeOptions: [],
  },

  /**
   * Client form errors object
   * @type {Object}
   */
  errors: {},

  /**
   * Client form mode
   * @type {String}
   */
  mode: 'create',

  /**
   * Client form path
   * @type {String}
   */
  path: '/api/b2b/subjects',
};

export default subjectForm;
